import { FC } from "react";
import { AccessToAccountsTabs } from "../AccessToAccountsTabs";

export const AccessToAWSAccountTabs: FC = () => {
  return <AccessToAccountsTabs />;
};
